import React from 'react';
import Link from '$shared/components/link';
import Headline from '$shared/components/headline';
import { IHeadline } from '~/lib/data-contract';

export const CarouselItem = ({ item }: { item: any }) => {
    const imageSrc = item.media?.desktop?.src;

    const link = item.callToAction;

    const headline: IHeadline | undefined = item.headline;

    const content = (
        <>
            {imageSrc && (
                <img
                    src={imageSrc}
                    alt={item.media?.desktop?.alt || ''}
                />
            )}

            <div className="carousel-content">
                {headline?.text && (
                    <Headline
                        as={headline.tag}
                        size={headline.style}
                        hideOnMobile={headline.hideOnMobile}
                        noMargin
                    >
                        {headline.text}
                    </Headline>
                )}

                {item.text?.html && (
                    <div
                        className="carousel-text"
                        dangerouslySetInnerHTML={{ __html: item.text.html }}
                    />
                )}
            </div>
        </>
    );

    if (!link?.url) {
        return (
            <div className={`carousel-item ${item.flipTextColor ? 'flip-color' : ''}`}>
                {content}
            </div>
        );
    }

    return (
        <Link
            href={link.url}
            target={link?.target}
            className={`carousel-item ${item.flipTextColor ? 'flip-color' : ''}`}
        >
            {content}
        </Link>
    );
};